import React from 'react';
import { createSvgIcon } from './createSvgIcon';
export const BoneIcon = createSvgIcon({
    displayName: 'Bone',
    path: (React.createElement("path", { d: "M28.576 6.01c.88-.608 1.4-1.585 1.424-2.63C30 1.525 28.293.004 26.18.004c-1.476-.077-2.784.907-3.068 2.306H6.87C6.588.917 5.29-.065 3.82.004 1.707.004 0 1.525 0 3.38.01 4.425.538 5.402 1.418 6.01.543 6.614.016 7.583 0 8.62c0 1.865 1.707 3.376 3.82 3.376 1.592.067 2.96-1.08 3.115-2.6H23.06c.16 1.53 1.528 2.675 3.12 2.6 2.1 0 3.82-1.52 3.82-3.376-.018-1.04-.547-2.008-1.424-2.6z", fillRule: "nonzero" })),
    viewBox: '0 0 30 12',
});
